/**
 * Kala ad landing pages: after a successful add to cart, go straight to checkout.
 *
 * The landing layout has no header, so Horizon's cart drawer isn't on the page and an add
 * would otherwise only flip the button to "Added". Cold ad traffic gets the shortest path.
 */
import { ThemeEvents } from '@theme/events';

document.addEventListener(ThemeEvents.cartUpdate, (event) => {
  const data = event.detail?.data;
  if (data?.source !== 'product-form-component' || data.didError) return;
  window.location.href = '/checkout';
});
